import React from 'react';
import { Section, FadeIn } from './ui';
import { UserXIcon, ShuffleIcon, HeartCrackIcon, FileTextIcon, LineChartIcon, FileWarningIcon } from 'lucide-react';
export function Problem() {
  const problems = [{
    icon: <UserXIcon className="w-6 h-6" data-id="element-6257" />,
    title: 'Attendees arrive unprepared',
    desc: 'No pre-event context or goal alignment.'
  }, {
    icon: <ShuffleIcon className="w-6 h-6" data-id="element-6258" />,
    title: 'Networking is random',
    desc: 'People stick to who they already know.'
  }, {
    icon: <HeartCrackIcon className="w-6 h-6" data-id="element-6259" />,
    title: 'Wellness preferences are missed',
    desc: 'Introverts and non-drinkers feel left out.'
  }, {
    icon: <FileTextIcon className="w-6 h-6" data-id="element-6260" />,
    title: 'Agendas feel generic',
    desc: "Standard formats that don't fit the specific team."
  }, {
    icon: <LineChartIcon className="w-6 h-6" data-id="element-6261" />,
    title: 'Engagement is hard to track',
    desc: 'No real way to measure participation.'
  }, {
    icon: <FileWarningIcon className="w-6 h-6" data-id="element-6262" />,
    title: 'Post-event reporting is weak',
    desc: 'Just a basic survey with low response rates.'
  }];
  return <Section className="bg-white" data-id="element-6263">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-6264">
        <FadeIn data-id="element-6265">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-6266">
            Most offsites are expensive, but hard to measure.
          </h2>
          <p className="text-lg text-slate-600" data-id="element-6267">
            Hotels and planners handle rooms, meals, transfers, and logistics.
            But the experience layer is usually fragmented.
          </p>
        </FadeIn>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-6268">
        {problems.map((prob, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-6269">
            <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 h-full flex flex-col items-start" data-id="element-6270">
              <div className="bg-white p-3 rounded-xl shadow-sm mb-4 text-brand-coral" data-id="element-6271">
                {prob.icon}
              </div>
              <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-6272">
                {prob.title}
              </h3>
              <p className="text-sm text-slate-600" data-id="element-6273">{prob.desc}</p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} data-id="element-6274">
        <div className="bg-brand-navy text-white p-8 rounded-2xl text-center max-w-4xl mx-auto shadow-xl relative overflow-hidden" data-id="element-6275">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-teal via-brand-coral to-brand-teal" data-id="element-6276"></div>
          <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-6277">
            Offsite+ fixes the layer between logistics and outcomes.
          </h3>
        </div>
      </FadeIn>
    </Section>;
}